import { getSettingRetailerExclusivityAgreements } from "@faire/help-center-utils/settings/getSettingRetailerExclusivityAgreements";
export var HowDoesSignupWorkIA = function HowDoesSignupWorkIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return HOW_DOES_SIGNUP_OFFER_WORK_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [HOW_DOES_SIGNUP_OFFER_WORK_DESCRIPTION(strictLocalize)];
    }
  };
};
var HOW_DOES_SIGNUP_OFFER_WORK_TITLE = function HOW_DOES_SIGNUP_OFFER_WORK_TITLE(strictLocalize) {
  if (getSettingRetailerExclusivityAgreements()) {
    return strictLocalize({
      id: "JvfdpN",
      defaultMessage: [{
        "type": 0,
        "value": "Comment bénéficier de l'offre"
      }]
    });
  } else {
    return strictLocalize({
      id: "w7CyhN",
      defaultMessage: [{
        "type": 0,
        "value": "Comment fonctionne l'offre d'inscription"
      }]
    });
  }
};
var HOW_DOES_SIGNUP_OFFER_WORK_DESCRIPTION = function HOW_DOES_SIGNUP_OFFER_WORK_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "x52u0e",
    defaultMessage: [{
      "type": 0,
      "value": "Lorsque vous utilisez le lien d'une marque pour vous inscrire sur Faire, vous bénéficiez d'une offre d'inscription, notamment une réduction et la livraison gratuite pendant un an auprès de cette marque. La réduction est appliquée automatiquement lors du paiement d'une commande et expire 7 jours après l'inscription."
    }]
  });
};